export let reportJunk = "sFtCVd";
export default {reportJunk};